import { OPTIONS_META } from '@/constants/countries';
export const text = {
    ENRICHES_VAT: {
        title: (val) => `${val ? 'E' : 'Does not e'}nrich VAT`,
        description: () => OPTIONS_META.ENRICHES_VAT.DESCRIPTION,
    },
    ALLOW_PUBLIC_ON_UNMANAGED: {
        title: (val) => `${val ? 'Allows' : 'Disallows'} public companies on unmanaged flows`,
        description: () => OPTIONS_META.ALLOW_PUBLIC_ON_UNMANAGED.DESCRIPTION,
    },
    ALLOW_PUBLIC_ON_MANAGED: {
        title: (val) => `${val ? 'Allows' : 'Disallows'} public companies on unmanaged flows`,
        description: () => OPTIONS_META.ALLOW_PUBLIC_ON_MANAGED.DESCRIPTION,
    },
    COLLECT_OPERATING_ADDRESS_ON_COMPANY_DETAILS: {
        title: (val) => `${val ? 'C' : "Doesn't c"}ollect operating address on company details`,
        description: () => OPTIONS_META.COLLECT_OPERATING_ADDRESS_ON_COMPANY_DETAILS.DESCRIPTION,
    },
    COLLECT_COMPANY_DETAILS_ON_UNMANAGED: {
        title: (val) => `${val ? 'C' : "Doesn't c"}ollect company details collection on unmanaged`,
        description: () => OPTIONS_META.COLLECT_COMPANY_DETAILS_ON_UNMANAGED.DESCRIPTION,
    },
    REGISTRATION_ID_KIND: {
        title: () => 'Registration ID Step',
        description: (val) => OPTIONS_META.REGISTRATION_ID_KIND.OPTIONS_DESCRIPTIONS[val],
    },
    VAT_ID_KIND: {
        title: () => 'VAT ID Step',
        description: (val) => OPTIONS_META.VAT_ID_KIND.OPTIONS_DESCRIPTIONS[val],
    },
    SOLE_TRADER_KIND: {
        title: () => 'Sole Trader step (only available if registration is nor mandatory)',
        description: (val) => OPTIONS_META.SOLE_TRADER_KIND.OPTIONS_DESCRIPTIONS[val],
    },
    SUPPORT_EMAIL: {
        title: () => 'Email for support',
        description: (val) => val,
    },
    SUPPORT_PHONE: {
        title: () => 'Phone for support',
        description: (val) => val,
    },
    MOS_SUPPORT_PHONE: {
        title: () => 'Phone for onboarding support',
        description: (val) => val,
    },
    KLARNA_COM_SUPPORT_LINK: {
        title: () => 'Klarna.com support link',
        description: (val) => val,
    },
    KLARNA_COM_PRODUCTS_LINK: {
        title: () => 'Klarna.com products link',
        description: (val) => val,
    },
    PRODUCT_TEMPLATE_GROUP: {
        title: () => 'Which group of templates is used for this market',
        description: (val) => val,
    },
};
